import React from 'react'
import image from '../images/baner.jpg'
import '../styles/about.css'

const AboutPage = () => {
    return (

        <div id="section1" className="text-center" >
            <img src={image} className="w-100" alt="Responsive" />
            <h1>o mnie.</h1>
            <p>Nazywam się Malwina Pietrzak. Ukończyłam studia I i II stopnia na kierunku Architektura Wnętrz na Uniwersytecie Artystycznym w Poznaniu. W projektowaniu wnętrz najważniejsza jest dla mnie ergonomia, którą stawiam na równi z estetyką. Cenię sobie unikatowość, indywidualny charakter wnętrza i ponadczasowe rozwiązania z uwzględnieniem najnowszych trendów.
            Wsłuchuję się w styl życia inwestora, jego potrzeby i upodobania by na tej podstawie tworzyć wnętrza idealnie pasujące do ich właścicieli.
            MP projekt to młoda, rozwijająca się firma, którą założyłam w 2018 roku. Ciągle szukam nowych wyzwań i mam niezliczone pokłady energii oraz chęci do tworzenia.
Jeżeli jesteś zainteresowany współpracą zachęcam do kontaktu.</p>
        </div>

    );
}

export default AboutPage;